import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PERSONA_ONBOARDING = {
  brand: "/onboarding/brand",
  agent: "/onboarding/agency",
  club: "/onboarding/agency",
};

export default function ProtectedRoute({ children, requireOnboarding = true }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div className="min-h-screen bg-bg flex items-center justify-center"><div className="label-eyebrow">Loading…</div></div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireOnboarding && user.onboarded === false) {
    const path = PERSONA_ONBOARDING[user.account_type] || "/onboarding";
    if (location.pathname !== path) return <Navigate to={path} replace />;
  }
  return children;
}
